export enum WORKER_TOPIC {
  addFrame = 'addFrame',
}
